if (!customElements.get('drawer-gifts')) {
  class CartGifts extends HTMLElement {
    constructor() {
      super();
      this.config = JSON.parse(this.dataset.config).data
      this.forms = document.querySelectorAll('product-form')
      this.cartItems = document.querySelector('cart-items')

      this.config.gifts.forEach(gift =>{
        gift.price = gift.price * 100;
      })

      if(this.config.add_gift_automatically){
        document.addEventListener('on:cart:add', e => this.checkAddToCart(e.detail.cart))
        
        if(this.cartItems){
          this.cartItems.addEventListener('on:line-item:change', e => this.checkAddToCart(e.detail.cart))
        }
      }else{
        if(this.cartItems){
          this.cartItems.addEventListener('on:line-item:change', e => this.checkAddToCart(e.detail.cart))
        }
      }

      document.addEventListener('DOMContentLoaded', () => {
        fetch(`${theme.routes.cart}.js`)
        .then(response => response.json())
        .then(data => {
          this.checkAddToCart(data)
        })
      })
    }

    checkAddToCart(cart){
      this.checkoutBtn = document.querySelector('cart-drawer button[name="checkout"]')
      this.config.gifts.forEach(gift =>{
        const productInCart = cart.items.find(item => item.id === Number(gift.product_id));
        const productInCartById = cart.items.find(item => item.product_id === Number(gift.product_id));
        if(this.config.add_gift_automatically && gift.auto_add_available){
          if(cart.total_price > gift.price){
            if(!productInCart) this.autoAddToCart(Number(gift.product_id))
          }else{
            if(productInCart) this.autoRemoveFromCart(Number(gift.product_id))
            if(productInCartById) this.autoRemoveFromCart(productInCartById.id)
          }
        }else{
          if(cart.total_price < gift.price){
            if(productInCart) this.autoRemoveFromCart(Number(gift.product_id))
            if(productInCartById) this.autoRemoveFromCart(productInCartById.id)
          }
        }

        if(!gift.auto_add_available && cart.total_price > gift.price){
          if(!productInCart && !productInCartById){
            this.checkoutBtn.setAttribute('disabled', 'disabled')
          }else{
            this.checkoutBtn.removeAttribute('disabled')
          }
        }
      })
    }

    autoAddToCart(productId){
      let formData = {
        'items': [{
         'id': productId,
         'quantity': 1,
          properties: {
            'Gift': 'FREE Gift'
          }
        }]
       };
       
       fetch(`${theme.routes.cartAdd}.js`, {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify(formData)
       })
       .then(response => {
         return response.json();
       })
       .then(response => {
        this.cartItems.refresh()
       })
       .catch((error) => {
         console.error('Error:', error);
       });
    }

    autoRemoveFromCart(productId){
      let updates = {
        [productId]: 0
      };
       
       fetch(`${theme.routes.cartUpdate}.js`, {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify({ updates })
       })
       .then(response => {
         return response.json();
       }).then(response => {
        this.cartItems.refresh()
        this.checkAddToCart(response)
        const viewCart = document.querySelector('.cart-drawer__view-cart');
        if (viewCart) viewCart.hidden = true;
       })
       .catch((error) => {
         console.error('Error:', error);
       });
    }
    disableCheckoutIfOnlyGifts(cart) {
      const checkoutBtn = document.querySelector('cart-drawer button[name="checkout"]');
      if (!checkoutBtn) return;

      // Run immediate check
      const hasNonGift = cart.items.some(item => !item.properties || item.properties.Gift !== 'FREE Gift');
      console.log('[Gift Helper] Immediate check:', hasNonGift ? 'OK to checkout' : 'Only gifts');
      
      if (!hasNonGift) {
        checkoutBtn.classList.add('disabled-checkout');
      } else {
        checkoutBtn.classList.remove('disabled-checkout');
      }

      // 🔁 Run a second check after a short delay (to catch async updates)
      setTimeout(() => {
        fetch(`${theme.routes.cart}.js`)
          .then(res => res.json())
          .then(latestCart => {
            const hasNonGiftAfter = latestCart.items.some(item => !item.properties || item.properties.Gift !== 'FREE Gift');
            console.log('[Gift Helper] Re-check after delay:', hasNonGiftAfter ? 'OK to checkout' : 'Only gifts (still)');
            
            if (!hasNonGiftAfter) {
              checkoutBtn.classList.add('disabled-checkout');
            } else {
              checkoutBtn.classList.remove('disabled-checkout');
            }
          });
      }, 500); // 0.5s delay
    }

  }

  customElements.define('drawer-gifts', CartGifts);
}
